import { action, extendObservable } from 'mobx'
import {URL_GET_PLAN, URL_GET_PROJECT} from '../constants/index';
import axios from 'axios';

class ProjectData {

    constructor() {
        extendObservable(this, {
            loading: false,
            type: 'project',
            subType: 'บ้านเดี่ยว', // บ้านเดี่ยว, ทาวเฮาส์, อาคารพานิชย์
            listSubType: [],
            projectType: [],
            projectIdSelected: null,
            projectDataSelected: null,
            plans: [],
            planIdSelected: null,
        })

    }

    @action resetWizard() {
        this.type = 'project';
        this.subType = 'บ้านเดี่ยว';
    }

    @action setType(val) {
        this.type = val;
        this.planIdSelected = null;
    }
    @action setSubType(val) {
        this.subType = val;
        this.projectType.map( (value) => {
            if(value.title === val) {
                this.projectIdSelected = value.projects[0].id;
            }
        });

    }

    @action isSelectProject(id) {
        this.projectIdSelected = id;
        this.projectType.map( (value) => {
            if(this.subType === value.title){
                value.projects.map( (data) => {
                    if(id === data.id){
                        this.projectDataSelected = data; /// for Show on plan page
                    }
                    return true;
                });
            }
        });
    }

    @action setProjectData(data) {
        this.subType = 'บ้านเดี่ยว';
        this.type = 'project';
        this.listSubType = [];
        this.projectType = [];
        this.projectIdSelected = null;
        this.plans = [];
        this.planIdSelected = null;
        this.listSubType = [];
        this.projectType = data.projectType;
        this.projectIdSelected = data.projectType[0].projects[0].id;
        data.projectType.map( (value) => {
            this.listSubType[this.listSubType.length] = value.title;
            return true;
        });
        this.isSelectProject(this.projectIdSelected)
        this.loading = false;
    }

    @action
    getProject() {
        this.loading = true;
        let option = {
            method : "GET",
            url: URL_GET_PROJECT,
            headers: {
                'Content-Type': 'application/json'
            }
        };

        axios(option)
            .then((res) => {
                if (res.status === 200) {
                    return res.data;
                }
            })
            .then((data) => {
                // console.log('getProject : data :: ',data);
                this.setProjectData(data.responseObject);
            })
            .catch((err) => {
                console.log(err);
                this.loading = false;
            })
    }


    @action setPlanData(data) {
        this.plans = data.plans;
        this.planIdSelected = data.plans[0].id;
        this.loading = false;
    }

    @action isSelectPlan(id) {
        this.planIdSelected = id;
    }

    @action getPlan() {
        this.loading = true;
        let option = {
            method : "GET",
            url: URL_GET_PLAN+'?prj='+this.projectIdSelected,
            headers: {
                'Content-Type': 'application/json'
            }
        };

        axios(option)
            .then((res) => {
                if (res.status === 200) {
                    return res.data;
                }
            })
            .then((data) => {
                // console.log('getPlan : data :: ',data);
                this.setPlanData(data.responseObject);
            })
            .catch((err) => {
                console.log(err)
            })
    }

}

export default ProjectData;


// WEBPACK FOOTER //
// ./src/stores/ProjectData.js